'use client';

import { PanelDialog } from '@/components/ui/layout/PanelDialog';
import { GetStartedFlow } from './GetStartedFlow';

export interface GetStartedDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  surface?: string;
}

export function GetStartedDialog({
  open,
  onOpenChange,
  surface = 'landing_dialog',
}: GetStartedDialogProps) {
  return (
    <PanelDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Get started"
      desktopHeaderVariant="compact"
      desktopMaxWidth="sm:max-w-xl"
      desktopHeight="sm:h-auto sm:max-h-[90vh]"
      bodyClassName="p-0 sm:p-0 sm:pt-0 sm:pb-0"
      onBack={() => onOpenChange(false)}
    >
      <GetStartedFlow surface={surface} />
    </PanelDialog>
  );
}
